import { Box, Typography } from "@mui/material";
import { IconBox } from "../styledComponent/DashCount";

type DashSubInfoType = { icon: any, color: string, title: string, value: any, chip?: { value: string, progress: boolean }, border?: boolean };

const DashCount = ({ icon, color, title, value, chip, border = true }: DashSubInfoType) => {
    return (
        <Box sx={{ display: "flex", gap: "20px", justifyContent: "space-between", alignItems: "center" }}>
            <IconBox color={color}>
                {icon}
            </IconBox>

            <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography component="span" sx={{ fontSize: "16px" }}>{title}</Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Typography variant="h5" component="span">{value}</Typography>
                    {/* {
                        chip?.progress?
                        <GraphChip color="#219653" bg="rgba(33, 150, 83, 0.2)" mt={1}>
                            <CallMadeIcon/>
                            <Typography>{chip.value}</Typography>
                        </GraphChip>
                        : ""
                    } */}
                </Box>
            </Box>

            {
                border ? <Box sx={{ width: "2px", height: "100%", background: "rgba(49, 80, 161, 0.2)", marginLeft: "24px" }}></Box> : ""
            }

        </Box>
    )
}

export default DashCount
